import React from 'react';

import AlertIcon from '!!react-svg-loader!./assets/alert.svg';
import AnnouncementIcon from '!!react-svg-loader!./assets/announcement.svg';
import ContentCardsIcon from '!!react-svg-loader!./assets/content-cards.svg';
import IconCardIcon from '!!react-svg-loader!./assets/icon-card.svg';
import VideoCardIcon from '!!react-svg-loader!./assets/video-card.svg';
import { getCategoryName, HIDDEN_TEMPLATES_CATEGORY } from 'commons/templates';
import {
  ComponentsSidebar,
  ComponentUnfilteredSession,
} from 'craft/components/ComponentsTab/types';
import { TemplateMetadata } from 'craft/components/TemplatesTab/types';

import { TemplateDropInBox } from './DropIns';

const TemplateBlockIconMapping = {
  524: <AnnouncementIcon />,
  523: <AlertIcon />,
  534: <VideoCardIcon />,
  525: <ContentCardsIcon />,
  526: <IconCardIcon />,
} as Record<number, JSX.Element>;

export const processTemplateBlocks = (
  templates: TemplateMetadata[],
): ComponentUnfilteredSession[] => {
  const blockCategories = [...new Set(templates.map(({ category }) => category))]
    .filter((category: string) => category !== HIDDEN_TEMPLATES_CATEGORY)
    .sort();

  return blockCategories
    .map(
      (category): ComponentUnfilteredSession => ({
        label: getCategoryName(category),
        // @ts-ignore
        anchor: ComponentsSidebar[getCategoryName(category)].anchor,
        builtIn: templates
          .filter((template) => template.category === category)
          .map((template) => ({
            label: template.name,
            Component: () => (
              <TemplateDropInBox
                templateId={template.id}
                thumbnail={TemplateBlockIconMapping[template.id]}
                label={template.name}
              />
            ),
          })),
      }),
    )
    .filter((section) => (section?.builtIn?.length || 0) > 0);
};
